var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(
      _vm.nomenclature &&
      _vm.nomenclature.unit_of_measurement &&
      _vm.nomenclature.unit_of_measurement.is_divisible &&
      _vm.nomenclature.unit_of_measurement.is_divisible === 1
    )?[_vm._v(" "+_vm._s(_vm.amount)+" ")]:[_vm._v(" "+_vm._s(_vm.amount.toString().replace(".000", ""))+" ")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }